import {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

export const tourSteps = [
  {
    selector: '.editor',
    title: 'Редактор кода',
    content: 'Это основной редактор для написания кода...',
    position: 'bottom'
  },
  {
    selector: '.preview',
    title: 'Предпросмотр',
    content: 'Здесь вы видите результат выполнения кода...',
    position: 'top'
  },
];

const OnboardingTour = ({steps}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [targetRect, setTargetRect] = useState(null);

  useEffect(() => {
    const shown = localStorage.getItem('onboardingShown');
    if (!shown) {
      setIsOpen(true);
      localStorage.setItem('onboardingShown', 'true');
    }
  }, []);

  useEffect(() => {
    if (!isOpen || currentStep >= steps.length) return;

    const element = document.querySelector(steps[currentStep].selector);
    if (element) {
      const rect = element.getBoundingClientRect();
      setTargetRect(rect);
    }
  }, [currentStep, isOpen, steps]);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(prev => prev + 1);
    } else {
      setIsOpen(false);
    }
  };

  const handlePrev = () => {
    setCurrentStep(prev => Math.max(0, prev - 1));
  };

  if (!isOpen || !targetRect) return null;

  return ReactDOM.createPortal(
    <Overlay>
      <HighlightBox
        style={{
          top: targetRect.top + window.scrollY,
          left: targetRect.left + window.scrollX,
          width: targetRect.width,
          height: targetRect.height,
        }}
      />

      <Tooltip
        style={{
          top: targetRect.top + window.scrollY + targetRect.height + 10,
          left: targetRect.left + window.scrollX,
        }}
      >
        <TooltipHeader>
          <h3>{steps[currentStep].title}</h3>
          <CloseButton onClick={() => setIsOpen(false)}>×</CloseButton>
        </TooltipHeader>
        <p>{steps[currentStep].content}</p>
        <Navigation>
          <span>{currentStep + 1} / {steps.length}</span>
          <div>
            {currentStep > 0 && (
              <NavButton onClick={handlePrev}>Назад</NavButton>
            )}
            <NavButton onClick={handleNext}>
              {currentStep === steps.length - 1 ? 'Завершить' : 'Далее'}
            </NavButton>
          </div>
        </Navigation>
      </Tooltip>
    </Overlay>,
    document.body
  );
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
`;

const HighlightBox = styled.div`
  position: absolute;
  border: 2px solid #4a90e2;
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(74, 144, 226, 0.5);
  pointer-events: none;
`;

const Tooltip = styled.div`
  position: absolute;
  background: white;
  border-radius: 8px;
  padding: 20px;
  max-width: 300px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const TooltipHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  &:hover {
    color: #333;
  }
`;

const Navigation = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
`;

const NavButton = styled.button`
  background: #4a90e2;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
  &:hover {
    background: #357abd;
  }
`;

export default OnboardingTour;